import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../toast.service';
import { MatBottomSheet} from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';
import { LocationService } from '../location.service';
import { AuthService } from '../auth.service';
import { Platform } from '@angular/cdk/platform';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { NativeGeocoder, NativeGeocoderOptions, NativeGeocoderResult } from '@ionic-native/native-geocoder/ngx';
let k=1;

@Component({
  selector: 'app-add-subscription',
  templateUrl: './add-subscription.component.html',
  styleUrls: ['./add-subscription.component.scss'],
})
export class AddSubscriptionComponent  {
  constructor(public service: ApiService,
    public auth: AuthService,
    public handler: HandlerService,
    public router: Router,
    private platform:Platform,
    private loc: Geolocation,
    private geoCoder:NativeGeocoder,
    public translate: TranslateService,
    public location: LocationService,
    public toast: ToastService,
    public bottomSheet: MatBottomSheet) { }

    loader:boolean = false;
    name;
    slot ="Before 9AM";
    services: any = [];
    category: any = [];
    minDate = new Date();
    maxDate = new Date();
    dateFormat;
    categoryName;
    nullCheck: boolean = false;
    show: boolean = false;
    checkId;
    slots ; 
    postTime;
    time = 'Time'
    date: any; 
    orderId;
    orderItems; 
    categoryId;
    subscriptions;
    productId;
    serviceName;
    editBool:boolean=false;
    activeInd: boolean = true;
    details;
    Vehicle = 'Hatchback'; 
    item:any;
    serviceId;
    subscription;
    serviceCost;
    items;
    id;
    url;
    tsdate:any;
    tDate:any;
    timePref;
    count;
    length;
    edate:any
    one:boolean = true;
    two:boolean;
    three:boolean;
    four:boolean;
    five:boolean;
    car = [
      { id: '1', name:"Monthly Subscription" ,note:"Service will be provided everyday for a month",cost:"500"}
          ];
     home =[
        { id: '2', name:"Monthly Subscription" ,note:"Service will be provided everyday for a month",cost:"500"},
            
      ];
    ionViewWillEnter(){
      this.dateFormat = this.auth.getDateformat();
      this.loader = true;
      this.service.getOrgCategory().subscribe((res: any) => {
        this.category=res;     
           })
           this.service.  getTimePref().subscribe((res: any) => {
            this.timePref=res;     
               })
           this.getSubscription();
           this.loader = false;
        let url=window.location.href
        this.url = window.location.href;
        this.id = this.url.split('/').pop();
        if(url.includes('edit')) {
          this.editBool=true;
          this.id= window.location.href.split('/').pop();
          this.service.getOrderById(this.id).subscribe((res:any)=>{
            this.orderItems=res;
            this.length=res.requestDates.length;
            this.count = this.length - 1;
            this.date=res.requestDates[this.count].apptDate;
            this.time=res.requestDates[this.count].apptTime;
            this.orderId=res.id;
            this.loader = false;
          })
          err=>{
            this.handler.err(err);
            this.loader=false;
          }
        }
        else{
          this.editBool = false;
        }
    }
    

    getSubscription(){
      this.loader = true;
      this.service.getAllSubscriptions().subscribe((res: any) => {
        this.subscription=res;
        this.subscription= this.subscription.filter(res =>{return res.activeInd == true}) 
        this.subscriptions= this.subscription.filter(res =>{return this.id == res.productId}) 
        this.loader = false;
           })
    }

    onInput() {
      this.location.autoComplete();
    }

    openBottomSheet(): void {
      let x = [
        { name: 'Hatchback' },
        { name: 'Sedan' },
        { name: 'SUV' },
        { name: 'Luxury'}
      ]
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: x,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        this.Vehicle = res.name;
      });
    }

    openBottomSheetTime(): void { 
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.timePref,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        this.slot = res.name;
      });
    }

    clearTime() {
    var x=this.returnDate1(this.date)
    var date =new Date(x); 
    if(this.one == true){
      this.edate = new Date(date.getFullYear(),date.getMonth(),date.getDate()+28)
    } else if(this.two == true){
      this.edate = new Date(date.getFullYear(),date.getMonth(),date.getDate()+84)
    } else if(this.three == true){
      this.edate = new Date(date.getFullYear(),date.getMonth(),date.getDate()+168)
    }   else if(this.four == true){
      this.edate = new Date(date.getFullYear(),date.getMonth(),date.getDate()+335)
    }     
      this.time = 'Time';
      this.slots = [];
      this.show = false;
    }
   
    // setTime(data, indx) {
    //    this.time = data.startTime;
    //   this.postTime = data;
    //   this.slots.map((res, i) => {
    //     indx == i ? res.style = 'active' : res.style = 'none';
    //   })
    //   setTimeout(() => {
    //     this.show = false;
    //   }, 200);
    // }
  

  // returnDate(data) {
  //   let date = data.getDate();
  //   date = date < 10 ? '0' + date : date;
  //   let month = data.getMonth() + 1;
  //   month = month < 10 ? '0' + month : month;
  //   let year = data.getFullYear();
  //   return date + '/' + month + '/' + year;
  // }

  returnDate1(data) {
    let date = data.getDate();
    date = date < 10 ? '0' + date : date;
    let month = data.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let year = data.getFullYear();
    return year + '-' + month + '-' + date;
  }


 
  open(){
    this.location.pop = true ;
  }
  close(){
      this.details= false;
  }

  createOrder(id) {
     this.loader = true;
    let postData = {
      customerId: localStorage.getItem('currentUserId'),
      delDoorNbr: this.location.houseNbr,
      delStreet: this.location.street,
      delCity: this.location.cityId,
      delState: this.location.stateId,
      status: 1,
      paymtStatus: 1,
      paymtMode: 1,
      items: [{ id: id, qty: '1' }],
      orgId: localStorage.getItem('organizationId'),
      orderType: 2
    }
    this.service.placeOrder(postData).subscribe((res: any) => {
      this.orderId = res.id;      
      this.getOrder(this.orderId);
      this.cart();
    },
      err => {
        this.handler.err(err);
        this.loader = false;
         })
  }

  
  getOrder(id) {
    this.service.getOrderById(id).subscribe((res: any) => {
     this.loader = false;
     this.orderItems = res;
    })
  }

  cart() {
    if(this.orderId)
   this.details = true;
    else
    this.handler.error('Please select an item')
  }

  UpdateService(){
   let x = this.returnDate1(this.date)
    let y = this.returnDate1(this.edate)
    this.details = false;
    this.loader = true;
      Object.assign(this.orderItems,{"type": 1,
      "capacityDefId":  '1',
      "apptTime": '6:00',
      "apptDate": x,
      "apptStartTime":'6:00',
      "apptEndTime": '9:00',
      "cnvcChargeApplied" : true,
      "requestDates": [
        {
            "apptDate": x,
            "apptTime":  '6:00',
            "apptEndTime": '9:00',
            "status": 1
        }]})
  this.service.updateOrder(this.orderId,this.orderItems).subscribe((res:any) =>{
    this.details = false;
    this.handler.res('Booked Successfully !!')
    localStorage.setItem('orderId', this.orderId);
    let url=window.location.href
    if(url.includes('edit')) {
      this.router.navigate(['/mysubscriptions']);    
       }
    else{
      this.router.navigate(['declaration/', + this.orderId]);
    }
   
  
    this.loader = false;
  },err => {
    this.loader = false;
    this.handler.err(err)
  })
  }


  
  
  getSlots(id) {
    this.show = true;
    let x = this.date.getDate();
    let y = this.date.getMonth() + 1;
    let z = this.date.getFullYear();
    let pass = x + '-' + y + '-' + z;
    let post = {
      "targetCenterId":  this.checkId,
      "targetSource":  this.checkId,
      "schElements": [1],
      "requestDate": pass,
      "status": ["SlotsAvailable"],
      "independentEntities": true,
      "slotDuration": 30
    }
    this.service.getTimeSlots(pass, post).subscribe((res: any) => {
      if (res == null) {
        this.nullCheck = true;
      }
      else {
        this.nullCheck = false;
        this.slots = res;
        this.slots.map(sum => Object.assign(sum, { style: 'none' }));
      }
  
    },
      err => {
           this.handler.err(err)
      })
  
  }

  cancelOrder() {
      this.router.navigate(['/mysubscriptions']);
  }

  oneClick(id){
    if(id==1) {
      this.date = undefined;
      this.edate = undefined;
      this.one = true;
      this.two = false;
      this.three = false;
      this.four = false;
      this.five = false;
    }else if(id==2) {
      this.date = undefined;
      this.edate = undefined;
      this.one = false;
      this.two = true;
      this.three = false;
      this.four = false;
      this.five = false;
    }else if(id==3) {
      this.date = undefined;
      this.edate = undefined;
      this.one = false;
      this.two = false;
      this.three = true;
      this.four = false;
      this.five = false;
    }else if(id==4) {
      this.date = undefined;
      this.edate = undefined;
      this.one = false;
      this.two = false;
      this.three = false;
      this.four = true;
      this.five = false;
    }else if(id==5) {
      this.date = undefined;
      this.edate = undefined;
      this.one = false;
      this.two = false;
      this.three = false;
      this.four = false;
      this.five = true;
    }
  }

  setLoc(){
    if(this.platform.ANDROID || this.platform.IOS){
        let options: NativeGeocoderOptions = { useLocale: true,maxResults: 1 };
      this.loc.getCurrentPosition().then(res => {
        this.geoCoder.reverseGeocode(res.coords.latitude, res.coords.longitude, options).then((result: NativeGeocoderResult[]) => {
            let x: any = result;
            localStorage.setItem('location', JSON.stringify(x));
            let loc;
            loc=JSON.parse(localStorage.getItem('location'));
            this.location.lat=loc[0].latitude;
            this.location.lon=loc[0].longitude;
             this.location.zipcode=loc[0].postalCode;
             this.location.street=loc[0].thoroughfare;
             this.location.stateId=loc[0].administrativeArea;
             this.location.cityId=loc[0].locality;    
             this.location.regionId=loc[0].subLocality;       
        })        
    })
 }

}

}
